function removeEmpty<O extends Record<string, any>>(obj: O) {
  return Object.entries(obj)
    .filter(([_, v]) => v != null)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {}) as O;
}

export default removeEmpty;
